import { Box, Typography } from '@mui/material'

import Anchor from '@ecm/ui/element/Anchor'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import GradientBox from '@ecm/ui/element/GradientBox'
import MainContainer from '@ecm/ui/element/MainContainer'

import mailDoneIcon from '/public/images/icon/mail_done.svg'

const Banner = () => (
  <MainContainer sx={{ mb: '5em', mt: '6em', pt: '0.5em', textAlign: 'center' }}>
    <GradientBox position="relative" p={{ md: '2.4em 3.5em 1.6em', xs: '6.5em 1em 1em' }}>
      <Box maxWidth={{ md: '500px', xs: '100%' }}>
        <Typography variant="h5" fontWeight="400" m="0">
          Not sure what a <b>virtual mailbox service</b> is?
        </Typography>
        <Anchor href="/virtual-mailbox" whiteCaret>
          Click here to learn more
        </Anchor>
      </Box>

      <Box
        position="absolute"
        bottom={{ md: '-3px', xs: 'unset' }}
        top={{ md: 'unset', xs: '-100px' }}
        right={{ lg: '5em', md: '4em', xs: '50%' }}
        sx={{
          transform: { md: 'unset', xs: 'translateX(50%)' },
        }}
      >
        <CloudflareImage src={mailDoneIcon} />
      </Box>
    </GradientBox>

    <Typography variant="p3" mt="1em">
      Ready to make your postal mail virtual? <Anchor href="/pricing">View our plans</Anchor> and
      get started!
    </Typography>
  </MainContainer>
)
export default Banner
